import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from '@ab/components';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';

class NavigationLink extends Component {
    render() {
        let props = {...this.props};

        delete props.dispatch;
        delete props.external;

        return <Link {...props} onClick={this._handleClick} target={this._getTarget()} />;
    }

    _handleClick = (event = {}) => {
        if (!this.props.external) {
            if (event.nativeEvent) {
                event.preventDefault();
            }

            this.props.dispatch(push(this.props.href));
        }

        if (typeof this.props.onClick === 'function') {
            this.props.onClick(event);
        }

        return true;
    };

    _getTarget() {
        if (this.props.target) {
            return this.props.target;
        } else if (this.props.external) {
            return '_blank';
        } else {
            return '';
        }
    }

    static defaultProps = {
        external: false,
        rel: 'noopener noreferrer',
        href: '/',
    };

    static propTypes = {
        external: PropTypes.bool,
        rel: PropTypes.string,
        target: PropTypes.string,
        href: PropTypes.string.isRequired,
        onClick: PropTypes.func,
    };

    static displayName = 'NavigationLink';
}

export default connect()(NavigationLink);
